if (!customElements.get('jc-vignerons-carousel')) {
  customElements.define(
    'jc-vignerons-carousel',
    class JCVigneronsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.jc-vignerons-carousel__track');
        this.cards = this.querySelectorAll('.jc-vignerons-carousel__card');
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');

        this.prevBtn?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextBtn?.addEventListener('click', () => this.scrollByCard(1));
      }

      scrollByCard(direction) {
        const card = this.cards[0];
        if (!card || !this.track) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }
    }
  );
}
